import { Modal } from "@/components/ui/modal";
import { StickyNote } from "lucide-react";
import { useI18n } from '@/hooks/useI18n';

interface ItineraryNotesModalProps {
  isOpen: boolean;
  onClose: () => void;
  note?: string;
}

export const ItineraryNotesModal: React.FC<ItineraryNotesModalProps> = ({
  isOpen,
  onClose,
  note
}) => {
  const { t } = useI18n();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('itinerary.itineraryNotes')}
      size="sm"
    >
      <div className="p-6">
        {note ? (
          <div className="space-y-4">
            <p className="text-gray-600 leading-relaxed whitespace-pre-wrap">
              {note}
            </p>
          </div>
        ) : (
          <div className="text-center py-8">
            <StickyNote className="h-12 w-12 text-gray-300 mx-auto mb-4" />
            <p className="text-gray-500">{t('itinerary.noNotesAvailable')}</p>
          </div>
        )}
      </div>
    </Modal>
  );
};
